import { MachineTypes } from "../Machine/MachineTypes";

export const ServiceMachineTypes = [...MachineTypes, "IT", "Other"];
